import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { captureEvent } from 'shared/helpers/captureEvent'
import { useBreakpoint } from 'shared/hooks/useBreakpoint'

import { currentTeamSelector } from '../redux/selectors/team'
import { currentUserSelector, isVendorUserSelector } from '../redux/selectors/users'
import { useProductSubscription } from './useProductSubscription'

export function useAnalyticsEvent() {
  const isVendorUser = useSelector(isVendorUserSelector)
  const user = useSelector(currentUserSelector)
  const team = useSelector(currentTeamSelector)
  const { isL2o } = useProductSubscription()
  const isSmMobile = useBreakpoint('sm')
  const isXsMobile = useBreakpoint('xs')

  const track = useCallback(
    (event: string, metadata: Record<string, any> = {}, options?: SegmentAnalytics.SegmentOpts) => {
      const _metadata = {
        team_id: team?.id,
        team_name: team?.name || 'No Company Created',
        user_id: user?.id,
        mobile: user?.mobile,
        first_name: user?.first_name,
        last_name: user?.last_name,
        is_team_admin: user?.is_team_admin,
        is_team_driver: user?.is_team_driver,
        feature_flags: user?.featureFlags,
        bundle_name: team?.product_subscription?.bundle_name,
        composition: team?.composition,
        is_sm_screen: isXsMobile ? false : isSmMobile,
        is_xs_screen: isXsMobile,
        is_vendor_user: isVendorUser,
        is_l2o: isL2o,
        ...metadata,
      }

      captureEvent(event, _metadata, options)
    },
    [
      team?.id,
      team?.name,
      user?.id,
      user?.featureFlags,
      user?.mobile,
      user?.first_name,
      user?.last_name,
      user?.is_team_admin,
      user?.is_team_driver,
      isVendorUser,
      team?.product_subscription?.bundle_name,
      team?.composition,
      isXsMobile,
      isSmMobile,
      isL2o,
    ]
  )

  return track
}
